import React from 'react'
// import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { sum } from 'd3-array'
import { Link } from '@ta-interaktiv/contentbricks'

const GROUPS = [
  {
    name: (
      <>
        Besonders gefährdete Personen
        <br />
        <strong>2,38 Mio.</strong>
      </>
    ),
    value: 2376301,
    rank: 1,
    color: '#E16D00'
  },
  {
    name: (
      <>
        Gesund&shy;heits&shy;personal
        <br />
        <strong>0,43 Mio.</strong>
      </>
    ),
    value: 426807,
    rank: 3,
    color: '#F1BE8D'
  },
  {
    name: (
      <>
        Kontakte von gefährdeten Personen
        <br />
        <strong>1,36 Mio.</strong>
      </>
    ),
    value: 1358055,
    rank: 4,
    color: '#2CA29F'
  },
  {
    name: (
      <>
        Übrige Erwachsene
        <br />
        <strong>2,93 Mio.</strong>
      </>
    ),
    value: 2934416,
    rank: 6,
    color: '#60B9B7'
  },
  {
    name: (
      <>
        Unter 18 Jahre
        <br />
        <strong>1,54 Mio.</strong>
      </>
    ),
    value: 1542361,
    color: '#d4d4d4'
  }
].reduce(
  (acc, cur) => [
    ...acc,
    { ...cur, pct: (cur.value / 8606033) * 100, left: sum(acc, d => d.pct) }
  ],
  []
)

// .group-chart {
//   position: relative;
// }

// @media screen and (max-width: 650px) {
//   .group-chart-labels {
//     display: none
//   }
// }

// .groups {
//   align-items: center;
//   display: flex;
// }

// .group-label {
//   line-height: 1.2;
//   font-size: 12px;
// }

// .group-chart-label {
//   position: absolute;
//   line-height: 1.2;
//   font-size: 12px;
//   padding: 1px;
// }

const Wrapper = styled.div`
  position: relative;
`

const BarChart = styled.div`
  align-items: center;
  display: flex;
  position: relative;
`

const Label = styled.div`
  line-height: 1.2;
  font-size: 12px;
  overflow: visible;
  width: ${props => props.width}%;
`

const Title = styled.div`
  margin-bottom: 10px;
  line-height: 1.3;
`
const SubTitle = styled.div`
  margin-bottom: 10px;
`

const Small = styled.div`
  font-size: 12px;
`

export default function GroupChart() {
  return (
    <Wrapper className='ta chart'>
      <Title>
        <strong>Impf-Priorisierung der Bevölkerung</strong>
        <br />
        Gesamtbevölkerung: 8,6 Mio.
      </Title>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end'
        }}
      >
        {GROUPS.map((d, i) => (
          <Label width={d.pct}>
            <div>
              {i == 0 ? (
                <div style={{ color: '#7d7d7d' }}>Abnehmende Priorität ➜</div>
              ) : i % 2 !== 0 ? (
                d.name
              ) : (
                ' '
              )}
            </div>

            <div
              style={{
                height: 10,
                borderLeft: i % 2 !== 0 ? '1px solid #7D7D7D' : 'none',
                marginLeft: 5
              }}
            ></div>
          </Label>
        ))}
      </div>
      <BarChart>
        <>
          {GROUPS.map((d, i) => (
            <div
              style={{
                width: `${d.pct}%`
              }}
            >
              <div
                style={{
                  height: 40,
                  margin: '0px 0',
                  background: d.color,
                  color: '#fff',
                  fontSize: 12,
                  display: 'flex',
                  lineHeight: 1.2,
                  alignItems: 'center',
                  padding: 5
                }}
              ></div>
            </div>
          ))}

          <Label
            style={{
              position: 'absolute',
              left: `${GROUPS[0].pct + GROUPS[1].pct}%`,
              height: '100%',
              border: '2px solid #16514F',
              width: `${GROUPS[2].pct + GROUPS[3].pct}%`,
              display: 'flex',
              color: '#16514F',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <strong>Breite Bevölkerung</strong>
          </Label>
        </>
      </BarChart>
      <div style={{ display: 'flex' }}>
        {GROUPS.map((d, i) => (
          <>
            <Label width={d.pct}>
              <div
                style={{
                  height: 10,
                  borderLeft: i % 2 == 0 ? '1px solid #7D7D7D' : 'none',
                  marginLeft: 5
                }}
              ></div>
              <div>{i % 2 == 0 ? d.name : ' '}</div>
            </Label>
          </>
        ))}
      </div>
      <div>
        <Small>
          Quelle:{' '}
          <Link href='https://www.admin.ch/gov/de/start/dokumentation/medienmitteilungen.msg-id-82838.html'>
            BAG
          </Link>
        </Small>
      </div>
    </Wrapper>
  )
}
